import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../../../Actions/AllAction';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import { withNamespaces } from 'react-i18next';
import moment from 'moment'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import { staffList, getStaffHistory, roleListGet } from '../Controller/UserController';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CustomNoRowsOverlay from '../../../../Utility/Components/CustomNoRowsOverlay'

function UserHistoryModalContent(props) {
    const [modules, setmodules] = useState([InfiniteRowModelModule]);
    const [defaultColDef, setdefaultColDef] = useState({
        flex: 1,
        minWidth: 50

    });

    const [components, setcomponents] = useState({
        loadingRenderer: (params) => {
            if (params.value !== undefined) {
                return params.value;
            } else {
                return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
            }
        },
    })




    const [columnDefs, setColumnDefs] = useState(
        [
            {
                headerName: 'Branch Name',
                field: "branch_name",
                minWidth: 200,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.userHistoryBranchrelations && params.data.userHistoryBranchrelations.hasOwnProperty('branch_name') && params.data.userHistoryBranchrelations.branch_name != null && params.data.userHistoryBranchrelations.branch_name != "") {
                            if (params.data.userHistoryBranchrelations.branch_name.length > 17) {
                                return <div className="usercursor">
                                    <OverlayTrigger overlay={<Tooltip className="my-custom-tooltip">{params.data.userHistoryBranchrelations.branch_name}</Tooltip>}>
                                        <span >{params.data.userHistoryBranchrelations.branch_name}</span>
                                    </OverlayTrigger>
                                </div>
                            } else {
                                return <div className="detailsViewContentInner">
                                    <div className="detailsViewContent">
                                        <span className='textrenderview'>
                                            {params.data.userHistoryBranchrelations.branch_name}
                                        </span>
                                    </div>
                                </div>
                            }
                        } else {
                            return <div>
                                <div className="detailsViewContent">
                                    <span className='textrenderview'>
                                        Agency
                                    </span>
                                </div>
                            </div>;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Designation',
                field: "role_name",
                minWidth: 200,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.userHistoryRolerelations && params.data.userHistoryRolerelations.hasOwnProperty('name') && params.data.userHistoryRolerelations.name != null && params.data.userHistoryRolerelations.name != "") {
                            if (params.data.userHistoryRolerelations.name.length > 17) {
                                return <div className="usercursor">
                                    <OverlayTrigger overlay={<Tooltip className="my-custom-tooltip">{params.data.userHistoryRolerelations.name}</Tooltip>}>
                                        <span >{params.data.userHistoryRolerelations.name}</span>
                                    </OverlayTrigger>
                                </div>
                            } else {
                                return <div className="detailsViewContentInner">
                                    <div className="detailsViewContent">
                                        <span className='textrenderview'>
                                            {params.data.userHistoryRolerelations.name}
                                        </span>
                                    </div>
                                </div>
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Date',
                field: "date",
                minWidth: 200,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        return <div className="detailsViewContentInner">
                            <div className="detailsViewContent">
                                <span className='textrenderview'>
                                    {params.data.createdAt && params.data.createdAt != null && params.data.createdAt != "" ? moment.utc(params.data.createdAt).format("DD-MM-YYYY") : ""}
                                </span>
                            </div>
                        </div>
                    } else {
                        return null;
                    }
                },
            },
        ]
    )

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridparams, setgridparams] = useState(null);
    const [hotelBranchFilterSelectedValue, setHotelBranchFilterSelectedValue] = useState("");
    const [designationFilterSelectedValue, setDesignationFilterSelectedValue] = useState("");
    const [designationFilterList, setDesignationFilterList] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState("");
    const [isDisableRole, setIsDisableRole] = useState(true);
    const gridRef = useRef();
    const staffHistoryRef = useRef(true);

    useEffect(() => {
        if (staffHistoryRef.current) {
            staffHistoryRef.current = false;
            if (['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type)) {
                agentDesignationGetApi().then((roleListData) => {
                    if (roleListData.length > 0) {
                        setDesignationFilterList(roleListData);
                    } else {
                        setDesignationFilterList([])
                    }
                })
                setColumnDefs([{
                    headerName: 'Designation',
                    field: "role_name",
                    minWidth: 200,
                    sortable: true,
                    suppressMovable: true,
                    cellRenderer: (params) => {
                        if (params.data) {
                            if (params.data.userHistoryRolerelations && params.data.userHistoryRolerelations.hasOwnProperty('name') && params.data.userHistoryRolerelations.name != null && params.data.userHistoryRolerelations.name != "") {
                                if (params.data.userHistoryRolerelations.name.length > 17) {
                                    return <div className="usercursor">
                                        <OverlayTrigger overlay={<Tooltip className="my-custom-tooltip">{params.data.userHistoryRolerelations.name}</Tooltip>}>
                                            <span >{params.data.userHistoryRolerelations.name}</span>
                                        </OverlayTrigger>
                                    </div>
                                } else {
                                    return <div className="detailsViewContentInner">
                                        <div className="detailsViewContent">
                                            <span className='textrenderview'>
                                                {params.data.userHistoryRolerelations.name}
                                            </span>
                                        </div>
                                    </div>
                                }
                            } else {
                                return null;
                            }
                        } else {
                            return null;
                        }
                    },
                },
                {
                    headerName: 'Date',
                    field: "date",
                    minWidth: 200,
                    sortable: true,
                    suppressMovable: true,
                    cellRenderer: (params) => {
                        if (params.data) {
                            return <div className="detailsViewContentInner">
                                <div className="detailsViewContent">
                                    <span className='textrenderview'>
                                        {params.data.createdAt && params.data.createdAt != null && params.data.createdAt != "" ? moment.utc(params.data.createdAt).format("DD-MM-YYYY") : ""}
                                    </span>
                                </div>
                            </div>
                        } else {
                            return null;
                        }
                    },
                },
                ])
            }
        }
    }, [])


    const onGridReady = useCallback((params) => {
        setgridparams(params)
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        var datasource = serverSideDataSource()
        params.api.setDatasource(datasource);
    });

    const resetDataGrid = (e = null) => {
        var datasource = serverSideDataSource(e)
        gridApi.setDatasource(datasource);
    }

    //user history aggrid server side api fn
    const serverSideDataSource = () => {
        return {
            getRows(params) {
                const { startRow, endRow, filterModel, sortModel } = params
                const { loaderStateTrue, loaderStateFalse, selectedUserId } = props;
                loaderStateTrue();
                let filters = {};
                let filter_op = {};
                let globalQueryParamshash = {};
                globalQueryParamshash["offset"] = startRow;
                globalQueryParamshash["limit"] = parseInt(process.env.PAGE_DATA_LIMIT);
                globalQueryParamshash["user_id"] = selectedUserId
                if (hotelBranchFilterSelectedValue && hotelBranchFilterSelectedValue != "") {
                    globalQueryParamshash['branch_id'] = hotelBranchFilterSelectedValue.value
                }
                if (designationFilterSelectedValue && designationFilterSelectedValue != "") {
                    globalQueryParamshash['role_id'] = designationFilterSelectedValue.value
                }
                if (sortModel.length > 0) {
                    const statusSortExists = sortModel.some(item => item.sort === "desc" || "asc");
                    if (!statusSortExists) {
                        sortModel.push({ "sort": "desc" });
                    }
                    globalQueryParamshash['sorting'] = sortModel;
                } else {
                    globalQueryParamshash['sorting'] = [{ "sort": "desc", colId: "date" }];
                }

                filters['filters'] = JSON.stringify(globalQueryParamshash)
                let filterServerside = Object.keys(JSON.parse(filters.filters)).length > 0 ? filters : null
                getStaffHistory(filterServerside).then((response) => {
                    if (response.success) {
                        if (response.data.length == 0 && startRow == 0) {
                            gridRef.current.api.showNoRowsOverlay();
                        } else {
                            gridRef.current.api.hideOverlay();
                        }
                        params.successCallback(response.data, response.total);
                    } else {
                        console.error(error);
                        params.failCallback();
                        Utility.toastNotifications("Something went wrong !", "Error", "error")
                    }
                    loaderStateFalse();
                }).catch((error) => {
                    console.error("************error*************", error)
                    if (error) {
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {

                    }
                });
            }
        };
    }

    const gridOptions = useMemo(
        () => ({
            infiniteInitialRowCount: 1,
            paginationPageSize: 100,
            rowBuffer: 0,
            rowModelType: 'infinite',
            suppressCellSelection: true,
            suppressHorizontalScroll: true,
        }),
        []
    )

    //branch and designation dropdown handle change
    const handleChangeUserFilter = (type, event) => {
        if (type == 'branch') {
            if (event) {
                setHotelBranchFilterSelectedValue(event)
                setSelectedBranchId(event.value)
                setDesignationFilterSelectedValue("")
            } else {
                setHotelBranchFilterSelectedValue("")
                setDesignationFilterSelectedValue("")
            }
        }
        if (type == 'designation') {
            if (event) {
                setDesignationFilterSelectedValue(event)
            } else {
                setDesignationFilterSelectedValue("")
            }
        }
    }

    //branch selection dropdown changes useeffect
    useEffect(() => {
        if (gridApi && hotelBranchFilterSelectedValue != "" && hotelBranchFilterSelectedValue.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && hotelBranchFilterSelectedValue == "") {
            resetDataGrid();
        }
    }, [hotelBranchFilterSelectedValue])


    //designation selection dropdown changes useeffect
    useEffect(() => {
        if (gridApi && designationFilterSelectedValue != "" && designationFilterSelectedValue.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && designationFilterSelectedValue == "") {
            resetDataGrid();
        }
    }, [designationFilterSelectedValue])

    //after selecting branch id , get designation list
    useEffect(() => {
        if (selectedBranchId != "") {
            designationGetApi(selectedBranchId).then((roleListData) => {
                if (roleListData.length > 0) {
                    setDesignationFilterList(roleListData);
                } else {
                    setDesignationFilterList([])
                }
            })
        }
    }, [selectedBranchId])

    useEffect(() => {
    }, [designationFilterSelectedValue])

    //get designation list api
    const designationGetApi = (selectedBranchId) => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = props;
            let data = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["is_active"] = 1;
            globalQueryParamshash["branch_id"] = selectedBranchId
            data['filters'] = JSON.stringify(globalQueryParamshash)
            loaderStateTrue();
            roleListGet(data).then((response) => {
                let roleListData = [];
                if (response.data.length > 0) {
                    response.data.map((value, idx) => {
                        let roleListObj = {};
                        roleListObj['label'] = value.name;
                        roleListObj['value'] = value.id;
                        roleListData.push(roleListObj)
                    })
                }
                resolve(roleListData)
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();

            });
        })
        return promise;
    }

    //get agent designation list
    const agentDesignationGetApi = () => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = props;
            let data = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["is_active"] = 1;
            data['filters'] = JSON.stringify(globalQueryParamshash)
            loaderStateTrue();
            let userType = props.userCredentials.user_details.user_type;
            roleListGet(data, userType).then((response) => {
                let roleListData = [];
                if (response.data.length > 0) {
                    response.data.map((value, idx) => {
                        let roleListObj = {};
                        roleListObj['label'] = value.name;
                        roleListObj['value'] = value.id;
                        roleListData.push(roleListObj)
                    })
                }
                resolve(roleListData)
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();

            });
        })
        return promise;
    }


    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);

    return (
        <div className="gridcontainer">
            <div className='filterSection'>
                <div className="gridtopviews gridtopviewsHistory">
                    {['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type) ? null : <div className="dropdownbox statusdropcontainer branchDropdownBox">
                        <AutosuggestComponent
                            handleOnChange={(e) => { handleChangeUserFilter('branch', e) }}
                            options={props.branchFilterList}
                            selectedValue={hotelBranchFilterSelectedValue}
                            name=''
                            isMulti={false}
                            placeholder="Branch"
                            isDisabled={false}
                            isClearable={true}
                            closeButton={false}
                            menuHeader="Branch"
                            isSearchable={true}

                        />
                    </div>}
                    <div className="dropdownbox statusdropcontainer">
                        <AutosuggestComponent
                            handleOnChange={(e) => { handleChangeUserFilter('designation', e) }}
                            options={designationFilterList}
                            selectedValue={designationFilterSelectedValue}
                            name=''
                            isMulti={false}
                            placeholder="Designation"
                            isDisabled={['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type) ? false : hotelBranchFilterSelectedValue != "" ? false : true}
                            isClearable={true}
                            closeButton={false}
                            menuHeader="Designation"
                            isSearchable={true}

                        />
                    </div>
                </div>
            </div>
            <div className='grid_content_inner'>
                <div className="ag-theme-alpine aggridview agprises historyGrid modalInnerGrid">
                    <AgGridReact
                        modules={modules}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        components={components}
                        rowSelection="single"
                        rowModelType="infinite"
                        onGridReady={onGridReady}
                        rowHeight={43.9}
                        headerHeight={40.8}
                        cacheBlockSize={process.env.PAGE_DATA_LIMIT}
                        gridOptions={gridOptions}
                        onSelectionChanged={(e) => { onSelectionChanged(e) }}
                        noRowsOverlayComponent={noRowsOverlayComponent}
                        ref={gridRef}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(UserHistoryModalContent));
